import React from 'react'
import { colors } from '../../../Components/consts'
import { CustomSelect } from '../../../Components/Layout'

type YearSelectProps = {
  min: number
  max: number
  current: number
  onChangeYear?: (year: number) => void
  color?: string
  suffix?: string
  prefix?: string
}

/**
 * Select year from allowed range
 */
export const YearSelect: React.FC<React.PropsWithChildren<YearSelectProps>> = ({
  min,
  max,
  current,
  onChangeYear,
  color = colors.blue,
  prefix = '',
  suffix = '',
}) => {
  const value = Math.max(Math.min(max, current), min).toString()
  const years = new Array(max - min + 1).fill(0).map((a, i) => i + min).reverse()

  const onChange = (option: string) => {
    const v = parseInt(option)
    onChangeYear && onChangeYear(v)
  }

  return (
    <CustomSelect
      options={years.map((year) => year.toString())}
      value={value}
      onChange={onChange}
      id="year-select"
      ariaLabel="Year select"
    />
  )
}
